//ng build --configuration=staging
export const environment = Object.freeze({
  GOAL_SETTING_URL:'https://goalstgapi.devinfinitylearn.in/',
  UAM_URL: 'https://stagingapi.devinfinitylearn.in/',
  CMS_URL: 'https://cmsapi.devinfinitylearn.in/',
  UAM_TO_CMS_CONVERSION :[

    {

      "UAM_Exam_Name": "NEET",

      "UAM_Grade_Name": "13th",

      "CMS_Exam_Name": "NEET",

      "CMS_Grade_Name": 13,

      "UAM_exam_id": 2,

      "UAM_grade_id": 7,

      "CMS_Exam_id": 1,

      "CMS_grade_id": 13

    },

    {

      "UAM_Exam_Name": "NEET",

      "UAM_Grade_Name": "12th",

      "CMS_Exam_Name": "NEET",

      "CMS_Grade_Name": 12,

      "UAM_exam_id": 2,

      "UAM_grade_id": 3,

      "CMS_Exam_id": 1,

      "CMS_grade_id": 12

    },

    {

      "UAM_Exam_Name": "NEET",

      "UAM_Grade_Name": "11th",

      "CMS_Exam_Name": "NEET",

      "CMS_Grade_Name": 11,

      "UAM_exam_id": 2,

      "UAM_grade_id": 2,

      "CMS_Exam_id": 1,

      "CMS_grade_id": 11

    },

    {

      "UAM_Exam_Name": "NEET",

      "UAM_Grade_Name": "10th",

      "CMS_Exam_Name": "NEET",

      "CMS_Grade_Name": 10,

      "UAM_exam_id": 2,

      "UAM_grade_id": 1,

      "CMS_Exam_id": 1,

      "CMS_grade_id": 10

    },

    {

      "UAM_Exam_Name": "NEET",

      "UAM_Grade_Name": "9th",

      "CMS_Exam_Name": "NEET",

      "CMS_Grade_Name": 9,

      "UAM_exam_id": 2,

      "UAM_grade_id": 9,

      "CMS_Exam_id": 1,

      "CMS_grade_id": 9

    },

    {

      "UAM_Exam_Name": "JEE Main",

      "UAM_Grade_Name": "13th",

      "CMS_Exam_Name": "JEE Main",

      "CMS_Grade_Name": 13,

      "UAM_exam_id": 1,

      "UAM_grade_id": 7,

      "CMS_Exam_id": 2,

      "CMS_grade_id": 13

    },

    {

      "UAM_Exam_Name": "JEE Main",

      "UAM_Grade_Name": "12th",

      "CMS_Exam_Name": "JEE Main",

      "CMS_Grade_Name": 12,

      "UAM_exam_id": 1,

      "UAM_grade_id": 3,

      "CMS_Exam_id": 2,

      "CMS_grade_id": 12

    },

    {

      "UAM_Exam_Name": "JEE Main",

      "UAM_Grade_Name": "11th",

      "CMS_Exam_Name": "JEE Main",

      "CMS_Grade_Name": 11,

      "UAM_exam_id": 1,

      "UAM_grade_id": 2,

      "CMS_Exam_id": 2,

      "CMS_grade_id": 11

    },

    {

      "UAM_Exam_Name": "JEE Main",

      "UAM_Grade_Name": "10th",

      "CMS_Exam_Name": "JEE Main",

      "CMS_Grade_Name": 10,

      "UAM_exam_id": 1,

      "UAM_grade_id": 1,

      "CMS_Exam_id": 2,

      "CMS_grade_id": 10

    },

    {

      "UAM_Exam_Name": "JEE Main",

      "UAM_Grade_Name": "9th",

      "CMS_Exam_Name": "JEE Main",

      "CMS_Grade_Name": 9,

      "UAM_exam_id": 1,

      "UAM_grade_id": 9,

      "CMS_Exam_id": 2,

      "CMS_grade_id": 9

    },

    {

      "UAM_Exam_Name": "JEE Advanced",

      "UAM_Grade_Name": "13th",

      "CMS_Exam_Name": "JEE Advanced",

      "CMS_Grade_Name": 13,

      "UAM_exam_id": 3,

      "UAM_grade_id": 7,

      "CMS_Exam_id": 3,

      "CMS_grade_id": 13

    },

    {

      "UAM_Exam_Name": "JEE Advanced",

      "UAM_Grade_Name": "12th",

      "CMS_Exam_Name": "JEE Advanced",

      "CMS_Grade_Name": 12,

      "UAM_exam_id": 3,

      "UAM_grade_id": 3,

      "CMS_Exam_id": 3,

      "CMS_grade_id": 12

    },

    {

      "UAM_Exam_Name": "JEE Advanced",

      "UAM_Grade_Name": "11th",

      "CMS_Exam_Name": "JEE Advanced",

      "CMS_Grade_Name": 11,

      "UAM_exam_id": 3,

      "UAM_grade_id": 2,

      "CMS_Exam_id": 3,

      "CMS_grade_id": 11

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "12th",

      "CMS_Exam_Name": "CBSE Grade 12",

      "CMS_Grade_Name": 12,

      "UAM_exam_id": 6,

      "UAM_grade_id": 3,

      "CMS_Exam_id": 12,

      "CMS_grade_id": 12

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "11th",

      "CMS_Exam_Name": "CBSE Grade 11",

      "CMS_Grade_Name": 11,

      "UAM_exam_id": 6,

      "UAM_grade_id": 2,

      "CMS_Exam_id": 11,

      "CMS_grade_id": 11

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "10th",

      "CMS_Exam_Name": "CBSE Grade 10",

      "CMS_Grade_Name": 10,

      "UAM_exam_id": 6,

      "UAM_grade_id": 1,

      "CMS_Exam_id": 10,

      "CMS_grade_id": 10

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "9th",

      "CMS_Exam_Name": "CBSE Grade 9",

      "CMS_Grade_Name": 9,

      "UAM_exam_id": 6,

      "UAM_grade_id": 9,

      "CMS_Exam_id": 9,

      "CMS_grade_id": 9

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "8th",

      "CMS_Exam_Name": "CBSE Grade 8",

      "CMS_Grade_Name": 8,

      "UAM_exam_id": 6,

      "UAM_grade_id": 15,

      "CMS_Exam_id": 8,

      "CMS_grade_id": 8

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "7th",

      "CMS_Exam_Name": "CBSE Grade 7",

      "CMS_Grade_Name": 7,

      "UAM_exam_id": 6,

      "UAM_grade_id": 14,

      "CMS_Exam_id": 7,

      "CMS_grade_id": 7

    },

    {

      "UAM_Exam_Name": "CBSE",

      "UAM_Grade_Name": "6th",

      "CMS_Exam_Name": "CBSE Grade 6",

      "CMS_Grade_Name": 6,

      "UAM_exam_id": 6,

      "UAM_grade_id": 13,

      "CMS_Exam_id": 6,

      "CMS_grade_id": 6

    },

    {

      "UAM_Exam_Name": "Aptitude Test",

      "UAM_Grade_Name": "5th",

      "CMS_Exam_Name": "Aptitude Test",

      "CMS_Grade_Name": 5,

      "UAM_exam_id": 4,

      "UAM_grade_id": 12,

      "CMS_Exam_id": 5,

      "CMS_grade_id": 5

    },

    {

      "UAM_Exam_Name": "Aptitude Test",

      "UAM_Grade_Name": "4th",

      "CMS_Exam_Name": "Aptitude Test",

      "CMS_Grade_Name": 4,

      "UAM_exam_id": 4,

      "UAM_grade_id": 11,

      "CMS_Exam_id": 5,

      "CMS_grade_id": 4

    },

    {

      "UAM_Exam_Name": "Aptitude Test",

      "UAM_Grade_Name": "3rd",

      "CMS_Exam_Name": "Aptitude Test",

      "CMS_Grade_Name": 3,

      "UAM_exam_id": 4,

      "UAM_grade_id": 10,

      "CMS_Exam_id": 5,

      "CMS_grade_id": 3

    },

    {

      "UAM_Exam_Name": "Foundation Test",

      "UAM_Grade_Name": "8th",

      "CMS_Exam_Name": "Foundation Test",

      "CMS_Grade_Name": 8,

      "UAM_exam_id": 5,

      "UAM_grade_id": 15,

      "CMS_Exam_id": 4,

      "CMS_grade_id": 8

    },

    {

      "UAM_Exam_Name": "Foundation Test",

      "UAM_Grade_Name": "7th",

      "CMS_Exam_Name": "Foundation Test",

      "CMS_Grade_Name": 7,

      "UAM_exam_id": 5,

      "UAM_grade_id": 14,

      "CMS_Exam_id": 4,

      "CMS_grade_id": 7

    },

    {

      "UAM_Exam_Name": "Foundation Test",

      "UAM_Grade_Name": "6th",

      "CMS_Exam_Name": "Foundation Test",

      "CMS_Grade_Name": 6,

      "UAM_exam_id": 5,

      "UAM_grade_id": 13,

      "CMS_Exam_id": 4,

      "CMS_grade_id": 6

    },

    {

      "UAM_Exam_Name": "Aptitude Test",

      "UAM_Grade_Name": "1st",

      "CMS_Exam_Name": "Aptitude Test",

      "CMS_Grade_Name": 1,

      "UAM_exam_id": 4,

      "UAM_grade_id": 16,

      "CMS_Exam_id": 5,

      "CMS_grade_id": 1

    },

    {

      "UAM_Exam_Name": "Aptitude Test",

      "UAM_Grade_Name": "2nd",

      "CMS_Exam_Name": "Aptitude Test",

      "CMS_Grade_Name": 2,

      "UAM_exam_id": 4,

      "UAM_grade_id": 17,

      "CMS_Exam_id": 5,

      "CMS_grade_id": 2

    },

    {

      "UAM_Exam_Name": "CUET",

      "UAM_Grade_Name": "12th",

      "CMS_Exam_Name": "CUET",

      "CMS_Grade_Name": 12,

      "UAM_exam_id": 9,

      "UAM_grade_id": 3,

      "CMS_Exam_id": 40,

      "CMS_grade_id": 12

    }

  ],

});
